import { ErrorHandler } from '@angular/core';
import * as Sentry from 'sentry-cordova';

export class SentryErrorHandler implements ErrorHandler {
  handleError(error) {
    try {
      Sentry.captureException(error.originalError || error);
    } catch (e) {
      console.error(e);
    }
  }
}